import { render, staticRenderFns } from "./ResponseDialog.vue?vue&type=template&id=47a7f0db"
import script from "./ResponseDialog.vue?vue&type=script&lang=js"
export * from "./ResponseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports